import { Location } from '@/reservation/reservation.model';
import { LocationKinds } from '@/common/enums/LocationKinds';

/**
 * Retrieves the country location from a given location object.
 * If the provided location is not a country, it recursively traverses its parent locations until a country location is found.
 *
 * @param {Location} location - The location object to retrieve the country from.
 * @returns {Location} The country location.
 */
export const countryFromLocation = (location: Location): Location => {
	if (!location) return null;
	return location.locationKind === LocationKinds.COUNTRY ? location : countryFromLocation(location?.parentLocation);
};
